import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';

import { Block } from '../styles/estilos';

class ApoyoDiccionario extends React.Component {
  render() {
    const ApoyoCont = styled.div`
      /* background: ${colors.claro}; */
      background-image: url('./img/svg/greek.svg');
      @media (max-width: 650px) {
        padding: 0 1em 0 1em;
      }
    `;
      const Titulo = styled.h4`
      color: ${colors.black};
      margin: .7em 0 .4em 0;
      font-size: 1.6em;
    }`;
      const Main = styled.h5`
      color: ${colors.main};
    }`;

    return (
      <ApoyoCont>
        <Block>
          <Titulo>{this.props.titular}</Titulo>
          <p>Ni el latín ni el griego son lenguas muertas, en todo caso, evolucionadas. Innumerables palabras y expresiones aún son usadas diariamente. Estas son un mínimo ejemplo.</p>
          <Main>Crisis económica (del griego)</Main>
          <p>Tal vez una de las expresiones más usadas, y con más trascendencia, en los últimos tiempos, conjunta tres palabras griegas: krisis, que significa cambio brusco o ruptura, junto a oikonomia, de oikos (casa) y nomia (administración)</p>
          <Main>Política (del griego)</Main>
          <p>No puede estar más de moda en nuestro país esta expresión que procede de politeia, o teoría de la polis, el nombre con el que los griegos designaban a la ciudad-estado, principal unidad administrativa de la época clásica. De la misma raíz son policía y cosmopolita, es decir ciudadano del mundo, cosmos.</p>
          <Main>Hecatombe (del griego)</Main>
          <p>Sabemos que designa a un gran mal o una gran mortandad. Hace referencia a la expresión ekatombe, que unía ekatom (cien) y be, la raíz de bous (buey) y era la práctica ritual de matar a cien bueyes como sacrificio a los dioses.</p>
          <Main>Idiota (del griego)</Main>
          <p>De la misma manera que chipriota es ciudadano de Chipre y cairota el habitante de El Cairo, idiota era en la antigua Grecia el que no era más que ciudadano de sí mismo (idios), es decir el que no se interesaba por los demás, por lo público. Origen igual tienen expresiones como idiosincrasia (forma de ser particular) o idioma (algo propio)</p>
          <Main>Inri (del latín)</Main>
          <p>De las iniciales de Iesus Nazarenus Rex Iudorum (Jesús Nazareno Rey de los Judíos), el rótulo que a modo de burla pusieron los romanos sobre la cruz de Cristo. A más inri significaría para mayor escarnio o burla.</p>
          <Main>Testículo (del latín)</Main>
          <p>No se sabe hasta qué punto es invento humorístico, pero la verdad es que testiculo en latín significa testigo, y su uso relativo a los genitales masculinos vendría de la costumbre romana de poner a sus gónadas como ‘testigos’ de su virilidad o incluso de que lo que decían era la verdad.</p>
          <Main>El trece, mala suerte (del latín)</Main>
          <p>No es una palabra, pero la atribución a este número de ser portador de mala suerte proviene de una fecha del calendario, puesto que el 13 coincidía con los idus de marzo, el día en que asesinaron a Julio César.</p>
        </Block>
      </ApoyoCont>
    );
  }
}

export default ApoyoDiccionario;



// WEBPACK FOOTER //
// ./src/components/ApoyoDiccionario.js